import { BLITZ_FONTS, Fonts, VERTEX_FONTS } from '@vertex-protocol/web-ui';
import { baseClientEnv } from 'common/environment/baseClientEnv';
import { BrandName } from 'common/environment/types';
import { Inter_Tight, JetBrains_Mono, Space_Grotesk } from 'next/font/google';

const ARCA_INTER_TIGHT = Inter_Tight({
  variable: '--font-inter-tight',
  subsets: ['latin'],
});

const ARCA_SPACE_GROTESK = Space_Grotesk({
  variable: '--font-space-grotesk',
  subsets: ['latin'],
});

const ARCA_JETBRAINS_MONO = JetBrains_Mono({
  variable: '--font-jetbrains-mono',
  subsets: ['latin'],
});

const ARCA_FONTS = {
  default: ARCA_INTER_TIGHT,
  title: ARCA_SPACE_GROTESK,
  mono: ARCA_JETBRAINS_MONO,
} satisfies Fonts;

const FONTS_BY_BRAND_NAME: Record<BrandName, Fonts> = {
  vertex: VERTEX_FONTS,
  blitz: BLITZ_FONTS,
  stackd: ARCA_FONTS,
};

export const FONTS = FONTS_BY_BRAND_NAME[baseClientEnv.brandName] ?? VERTEX_FONTS;
